import { Component } from 'react'
import Switch from '~/components/Switch/Switch'
import styles from '~/styles/ordersPage.dateFormatPicker.module.css'
import types from '~/types/ordersPage.ts'

export default class DateFormatPicker extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}

	public constructor(props) {
		super(props)
	}

	public render() {
		return (
			<div
				className={styles.main}
			>
				<div>
					<label>
						{this.props.t('Show time')}
					</label>
					<div>
						<div
							className={this.props.isHoursAndMinutesShown ? null : styles.bold}
							onClick={this._onClick.bind(this, false)}
	                    >
							{this.props.t('common:answerNo')}
						</div>
	                    <Switch
	                      isOn={this.props.isHoursAndMinutesShown}
	                      isGreenYes={true}
	                      onChange={this._onChange.bind(this)}
	                      saveToLocalStorage={false}
	                    />
	                    <div
							className={this.props.isHoursAndMinutesShown ? styles.bold : null}
							onClick={this._onClick.bind(this, true)}
						>
							{this.props.t('common:answerYes')}
						</div>
					</div>
				</div>
			</div>
		)
	}

	private _onClick(isYes) {
		if (this.props.setIsHoursAndMinutesShown) {
			this.props.setIsHoursAndMinutesShown(!!isYes)
		}
	}

	private _onChange() {
		if (this.props.setIsHoursAndMinutesShown) {
			const showTime = !this.props.isHoursAndMinutesShown
			if (this.props.onChange) {
				this.props.onChange(showTime)
			}
			this.props.onAction?.send({
		      action: 'Show Time',
		      actionData: {
		        file: 'components/OrdersPage/DateFormatPicker.tsx',
		        showTime,
		      },
		    })
			this.props.setIsHoursAndMinutesShown(showTime)
		}
	}
}
	